import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { authMe, authLogout } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const u = await authMe();
            setUser(u);
        } catch (e) {
            // 401 is expected for signed-out visitors — only log unexpected failures
            if (e?.response?.status && e.response.status !== 401) {
                console.error("Auth refresh failed", e);
            }
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const logout = useCallback(async () => {
        try {
            await authLogout();
        } catch (e) {
            console.error("Logout request failed", e);
        }
        setUser(null);
    }, []);

    const value = useMemo(
        () => ({ user, loading, refresh, setUser, logout }),
        [user, loading, refresh, logout]
    );

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
